import LearnitTagModelBase from '../_generated/modelBases/learnit-tag-model-base';

export default class LearnitTagModel extends LearnitTagModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
